import ScoreByDeviceTagWidget from './ScoreByDeviceTagWidget';
export default ScoreByDeviceTagWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/ScoreByDeviceTagWidget/index.js